import { ApplicationDocumentValidationStatus, ApplicationVehicle } from "pages/NewApplication/steps/types";
import { BaseModel } from "./BaseModel";
import { TagCompany } from "./TagCompany";

export class Vehicle extends BaseModel<ApplicationVehicle> {
	id: string;
	plate: string;
	renavamCode: string;
	numberOfAxis: number;
	vehicleBrand: string;
	vehicleModel: string;
	color: string;
	manufactureYear: number;
	modelYear: number;
	tagNumber: string;
	tagCompany?: TagCompany;
	documentValidationStatus: ApplicationDocumentValidationStatus;
	fieldsMissingFromApi: string[];

	constructor(data: ApplicationVehicle) {
		super(data);
		this.id = data.id ?? "";
		this.plate = data.plate ?? "";
		this.renavamCode = data.renavamCode ?? "";
		this.numberOfAxis = data.numberOfAxis ?? 0;
		this.vehicleBrand = data.vehicleBrand ?? "";
		this.vehicleModel = data.vehicleModel ?? "";
		this.color = data.color ?? "";
		this.manufactureYear = data.manufactureYear ?? 0;
		this.modelYear = data.modelYear ?? 0;
		this.tagNumber = data.tagNumber ?? "";
		this.documentValidationStatus = data.documentValidationStatus;
		this.tagCompany = TagCompany.getValueOrNew(data.tagCompany ?? {});
		this.fieldsMissingFromApi = data.fieldsMissingFromApi ?? [];
		if (data.vehicleModel?.includes("/")) {
			const [brand, model] = data.vehicleModel.split("/");
			this.vehicleBrand = brand;
			this.vehicleModel = model;
		}
	}
}
